import { jsxs as r, jsx as o } from "react/jsx-runtime";
import t from "dayjs";
import e from "@mui/joy/Box";
import i from "@mui/joy/Stack";
import m from "@mui/joy/Typography";
const a = ({ children: a2, ...l }) => r(i, { sx: { flexDirection: "row", alignItems: "flex-start", gap: 1 }, children: [o(e, { sx: { width: "44px", paddingInline: "6px", borderRadius: "4px", bgcolor: "neutral.100" }, children: o(m, { level: "body-xs", textColor: "neutral.600", children: t(l.createdAt).format("HH:mm") }) }), a2] });
export {
  a as TimeSection,
  a as default
};
//# sourceMappingURL=TimeSection.js.map
